import PropTypes from 'prop-types';

import { WysiwygContent } from './styles';
import transformHtml from './transformHtml';

const WysiwygText = ({ html = '', ...props }) => {
  if (html == null || html === '') {
    return null;
  }

  /** Remove empty paragraphs <p> */
  const sanitized = html.replace(/\s?<p>(\s|&nbsp;)+<\/p>\s?/, '');

  return (
    <WysiwygContent
      {...props}
      dangerouslySetInnerHTML={
        html == null ? undefined : { __html: transformHtml(sanitized) }
      }
    />
  );
};

WysiwygText.propTypes = {
  html: PropTypes.string,
};

export default WysiwygText;
